export { default } from "./HintedMCC";



// WEBPACK FOOTER //
// ./src/components/utils/HintedMCC/index.js